/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          :  AddEmailAddress.tsx
 *
 * Project Title :  Checkout
 *
 * Description    :
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Madhu Gali (H175591)
 *
 * @Date         : Aug 21, 2019
 *
 * @Version      : Version 1.0
 *
 * By            : Madhu Gali (H175591)
 * On            : Aug 23, 2019
 * Description   : ASDS-1089: Ability to add Email Functionality & Validations.
 * By            : H224423
 * On            : Oct 10, 2019
 * Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
 *  By            	: sivateja.p (H267743)
 * On            	: Oct 10, 2019
 * Description      : Removed the default emils from here, added in Shippng and billing (ASDS-1296)
 * By            : H224423
 * On            : Dec 12, 2019
 * Description   : ASDS-2083 Updated forge UI. Updated icon.
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 ******************************************************************************/

import * as React from "react";
import {
    Grid,
    Icon,
    Input,
} from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./ShippingAndBilling.css";
import "@scuf/styles/variables.scss";
import { connect } from 'react-redux';
import { IAddEmailAddressProps, IAddEmailAddressState } from "../utils/checkout-interfaces";
import ShippingBillingActions from "../redux/actions/shipping-billing-actions";

export class AddEmailAddress extends React.PureComponent<IAddEmailAddressProps, IAddEmailAddressState> {
    render() {
        const emailAddressLength: number = this.props.emailAddress.length;
        return (
            this.props.emailAddress.map((obj, index) => {
                return (
                    <Grid.Row key={index}>
                        <Grid.Column width={6} mWidth={8} sWidth={9} className="email-address">
                            <Input
                                className="input-example customWidth"
                                placeholder="Email Address"
                                indicator="required"
                                value={obj.address}
                                error={obj.error}
                                onChange={(value) => {
                                    this.props.updateEmailAddress(value, index);
                                }}
                                onBlur={() => {
                                    this.props.validateInputContents();
                                }}
                            />
                        </Grid.Column>
                        <Grid.Column width={4} mWidth={4} sWidth={3}>
                            <p className="alignPara">
                                {(emailAddressLength - 1) !== 0 &&
                                    <Icon root="common" name="badge-delete" size="large"
                                        data-test="delete-email-address"
                                        className="slider-controls-minus"
                                        onClick={() => {
                                            this.props.deleteEmailAddress(index)
                                        }} />}
                                &nbsp;
                                {(emailAddressLength - 1) === index &&
                                    <Icon root="common" name="badge-plus" className="slider-controls-plus" size="large"
                                        onClick={() => {
                                            this.props.addEmailAddress()
                                        }} />
                                }
                            </p><span className="email-label">Email Address</span>
                        </Grid.Column>
                    </Grid.Row>
                );
            })
        );
    }
}

function mapStateToProps(state) {
    let emailAddress = state.shippingBillingData.payload.shippingBillingObj.emailAddress;
    return {
        emailAddress,
    }
}

export default connect(mapStateToProps, {
    deleteEmailAddress: ShippingBillingActions.deleteEmailAddress,
    updateEmailAddress: ShippingBillingActions.updateEmailAddress,
    validateInputContents: ShippingBillingActions.validateInputContents,
    addEmailAddress: ShippingBillingActions.addEmailAddress,


})(AddEmailAddress);